<div id="content-section">
    <div id="content-main" class="responsive-content-main" [style]="{ 'margin-right': sidebarMaximized ? '370px' : '270px' }">
        <div id="content-sidebar" [class]="{ 'responsive-content-sidebar': sidebarOpen, 'hide-responsive-sidebar': !sidebarOpen }" [style]="{ width: sidebarMaximized ? '350px' : '250px' }" style="position: fixed; right: 20px">
            <div class="sticky-top">
                <small class="bg-white">
                  <a href="#" class="d-none d-md-inline" [title]="sidebarMaximized ? 'Minimize Sidebar' : 'Maximize Sidebar'" (click)="sidebarMaximized = !sidebarMaximized; $event.preventDefault()">
                    <i class="fas" [class]="{ 'fa-arrow-left': !sidebarMaximized, 'fa-arrow-right': sidebarMaximized }"></i>
                  </a>
                </small>
            </div>
            <div class="clearfix"></div>
            <div class="text-center pagination-small-margin pagination-center">
                <pagination
                (pageChanged)="fetchInvoices($event, null)"
                class="pagination-sm"
                [boundaryLinks]="true"
                [totalItems]="count"
                [maxSize]="5"
                [itemsPerPage]="fetchInvoicesParams.per_page"
                ngDefaultControl
                [(ngModel)]="fetchInvoicesParams.page"
                previousText="&lsaquo;"
                nextText="&rsaquo;"
                firstText="&laquo;"
                lastText="&raquo;"
                ></pagination>
            </div>
            <div class="text-center pt-1">
                <app-pagination-count
                    [count]="count"
                    singularName="Invoice"
                    pluralName="Invoices"
                ></app-pagination-count>
            </div>
            <hr class="my-1" />
            <div class="clearfix"></div>
            <div class="sticky-top bg-white">
                <h5 class="pt-2">
                <div class="pull-right float-right">
                    <button type="button" [disabled]="isFetching" class="btn btn-sm btn-outline-secondary" (click)="clearCreateForm()">Clear</button>
                </div>
                <span>
                    Create Invoices&nbsp;&nbsp;
                    <a href="javascript: void(0)" title="Search" style="cursor: pointer" (click)="createInvoices()">
                        <i *ngIf="!isFetching" class="fas fa-arrow-circle-right"></i>
                        <i *ngIf="isFetching" class="fas fa-spinner fa-pulse fa-fw"></i>
                    </a>
                </span>
                </h5>
                <hr class="my-1" />
            </div>
            <div class="row">
                <div class="col-md-12">
                    <form action="/invoices/new.json" method="get">
                        <div class="form-group">
                            <label for="activity_since">Only matters with activity since:</label>
                            <input type="text" class="form-control" ngDefaultControl [(ngModel)]="createInvoicesParams.activity_since" (dateSelected)="createInvoicesParams.activity_since = $event" name="activity_since" placeholder="Click to select date" [appDatepicker]="" id="activity_since" />
                        </div>
                        <div class="form-group">
                            <label for="no_activity_since">Only matters WITHOUT activity since:</label>
                            <input type="text" class="form-control" ngDefaultControl [(ngModel)]="createInvoicesParams.no_activity_since" (dateSelected)="createInvoicesParams.no_activity_since = $event" name="no_activity_since" placeholder="Click to select date" [appDatepicker]="" id="no_activity_since" />
                        </div>
                        <div class="form-group">
                            <label for="no_invoice_since">Only matters WITHOUT an invoice since:</label>
                            <input type="text" class="form-control" ngDefaultControl [(ngModel)]="createInvoicesParams.no_invoice_since" (dateSelected)="createInvoicesParams.no_invoice_since = $event" name="no_invoice_since" placeholder="Click to select date" [appDatepicker]="" id="no_invoice_since" />
                        </div>
                        <div class="form-group">
                            <label for="matters">Matter(s)</label>
                            <input class="form-control" type="text" id="matters" name="matters" ngDefaultControl [(ngModel)]="createInvoicesParams.matters">
                        </div>
                        <div class="form-group">
                            <div class="custom-control custom-radio custom-control-inline">
                                <input type="checkbox" id="will_be_paid" name="will_be_paid" class="custom-control-input" ngDefaultControl [(ngModel)]="createInvoicesParams.will_be_paid"/>
                                <label class="custom-control-label">WBP Only</label>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="minimum">Minimum amount due:</label>
                            <input type="text" class="form-control" name="minimum" placeholder="50" id="minimum" ngDefaultControl [(ngModel)]="createInvoicesParams.minimum"/>
                        </div>
                        <div class="form-group">
                            <label for="user-id">Matter User:</label>
                            <select class="form-control" id="user_id" name="user_id" ngDefaultControl [(ngModel)]="createInvoicesParams.user_id">
                                <option [value]=""></option>
                                <option [value]="matterUser.id" *ngFor="let matterUser of formOptions.matterUsers">{{matterUser.label}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="matter-type-id">Matter Types:</label>
                            <select class="form-control" id="matter_type_id" name="matter_type_id" ngDefaultControl [(ngModel)]="createInvoicesParams.matter_type_id">
                                <option [value]=""></option>
                                <option [value]="matterType.id" *ngFor="let matterType of formOptions.matterTypes">{{matterType.label}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="email-invoice">Send Method:</label>
                            <select class="form-control" id="email_invoice" name="email_invoice" ngDefaultControl [(ngModel)]="createInvoicesParams.email_invoice">
                                <option [value]=""></option>
                                <option [value]="sendMethod.id" *ngFor="let sendMethod of formOptions.sendMethods">{{sendMethod.label}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="is-uncollectable">Uncollectable Matters:</label>
                            <select class="form-control" id="is_uncollectable" name="is_uncollectable" ngDefaultControl [(ngModel)]="createInvoicesParams.is_uncollectable">
                                <option [value]=""></option>
                                <option [value]="uncollectableMatter.id" *ngFor="let uncollectableMatter of formOptions.uncollectableMatters">{{uncollectableMatter.label}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="exclude-perm">Permed Matters:</label>
                            <select class="form-control" id="exclude_perm" name="exclude_perm" ngDefaultControl [(ngModel)]="createInvoicesParams.exclude_perm">
                                <option [value]=""></option>
                                <option [value]="permedMatter.id" *ngFor="let permedMatter of formOptions.permedMatters">{{permedMatter.label}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="in-collections">Matters in Collection:</label>
                            <select class="form-control" id="in_collections" name="in_collections" ngDefaultControl [(ngModel)]="createInvoicesParams.in_collections">
                                <option [value]=""></option>
                                <option [value]="matterInCollection.id" *ngFor="let matterInCollection of formOptions.mattersInCollection">{{matterInCollection.label}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="exclude-types">Select Matter Types</label>
                            <select class="form-control" id="exclude_types" name="exclude_types" ngDefaultControl [(ngModel)]="createInvoicesParams.exclude_types">
                                <option [value]=""></option>
                                <option [value]="selectMatterType.id" *ngFor="let selectMatterType of formOptions.selectMatterTypes">{{selectMatterType.label}}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <button type="submit" class="btn btn-primary">Create Invoices</button>
                        </div>
                    </form>

                </div>
            </div>
        </div>
        <div id="content-inner" class="responsive-content-inner" style="padding: 0px 20px 10px 20px">
            <div class="container-shadow px-3 pb-4">
                <h2 class="pt-4 text-center">Invoices</h2>
                <hr class="mt-1 mb-2" />
                <div class="row p-4" style="overflow-x:auto;transform: rotateX(180deg);">
                    <table class="table table-striped" style="transform: rotateX(180deg);">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Matter</th>
                                <th>Document</th>
                                <th>Date</th>
                                <th>Balance</th>
                                <th>Status</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let invoice of invoices" [class.table-success]="invoice.is_paid" [class.table-secondary]="invoice.is_deleted">
                                <td><a [href]="'/invoices/' + invoice.id" target="_blank">{{ invoice.id }}</a></td>
                                <td><a [href]="'/matters/' + invoice.matter_id" target="_blank">{{ invoice.matter_id }}</a>&nbsp;{{invoice.matter.name}}</td>
                                <td><a [href]="authService.getAuthenticatedDownloadUrl('/documents/' + invoice.document_id + '/download')" target="_blank"><img *ngIf="invoice.document_image" [src]="invoice.document_image" />{{ invoice.document_name }} </a></td>
                                <td>{{ invoice.created_at }}</td>
                                <td>{{ invoice.amount | currency: 'USD':'symbol-narrow':'1.2-2' }}</td>
                                <td>
                                    <span *ngIf="invoice.is_paid" class="badge badge-success">Paid</span>
                                    <span *ngIf="invoice.is_deleted" class="badge badge-secondary">Withdrawn</span>
                                    <span *ngIf="!invoice.is_paid && !invoice.is_deleted" class="badge badge-warning">Pending</span>
                                </td>
                                <td>
                                    <div class="btn-group btn-group-sm" *ngIf="!invoice.is_deleted">
                                        <button type="button"
                                                class="btn btn-outline-success btn-sm"
                                                (click)="markPaid(invoice)"
                                                [disabled]="invoice.is_paid || invoice.actionInProgress"
                                                title="Mark as Paid">
                                            <i class="fas fa-check"></i>
                                        </button>
                                        <button type="button"
                                                class="btn btn-outline-danger btn-sm"
                                                (click)="withdrawInvoice(invoice)"
                                                [disabled]="invoice.actionInProgress"
                                                title="Withdraw Invoice">
                                            <i class="fas fa-undo"></i>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
<app-sidebar-toggle-btn [sidebarOpen]="sidebarOpen" (onClick)="sidebarOpen = !sidebarOpen"></app-sidebar-toggle-btn>
